import React from 'react';
import { getSignatureFillEmptyMessage, getSignatureFillSourceName } from '../../signatureFill.constants';
import { renderDate } from 'utils';

/**
 * A SIGNATURE block that mirrors one of the appointment's signatures.
 *
 * Nobody signs this on the form, so there is no canvas, no upload and no clear
 * button — it renders the signature line the way a signed form has always
 * looked, with the mirrored image on it when there is one and an honest reason
 * when there is not.
 *
 * `autoSignature` is resolved by the api per read and never stored (see
 * SignatureFillService), so the URL here is short-lived and the block follows
 * the appointment: signed later it appears, re-signed it changes, deleted it
 * goes back to an empty line.
 */
export const AutoSignatureElement = ({ item }) => {
    const signature = item?.autoSignature;
    const source = item?.properties?.signatureFill?.source;
    const sourceName = signature?.sourceName || getSignatureFillSourceName(source);

    return (
        <div className="auto-signature-block">
            <div className={`auto-signature-line ${signature ? '' : 'is-empty'}`}>
                {signature ? (
                    <img src={signature.url} alt={sourceName || 'signature'} className="auto-signature-image" />
                ) : (
                    <span className="auto-signature-empty">{getSignatureFillEmptyMessage(item?.signatureFillState)}</span>
                )}
            </div>
            <div className="auto-signature-caption">
                {sourceName && <span className="auto-signature-source">{sourceName}</span>}
                {signature?.signedBy && <span>{signature.signedBy}</span>}
                {signature?.signedAt && <span>{renderDate(signature.signedAt)}</span>}
            </div>
        </div>
    );
};
